export function toNumericDate(date, language) {
    var locale = language == "sl" ? "sl-SI" : "en-UK";
    return date.toLocaleDateString([locale], {
        year: "numeric",
        month: "numeric",
        day: "numeric",
    });
}
export function to24hTime(date, language) {
    var locale = language == "sl" ? "sl-SI" : "en-UK";
    return date.toLocaleTimeString([locale], {
        hour: "numeric",
        minute: "numeric",
        hour12: false,
    });
}
export function toLongDate(date, language) {
    var locale = language == "sl" ? "sl-SI" : "en-UK";
    return date.toLocaleDateString([
        locale
    ], {
        day: "2-digit",
        month: "long",
        year: "numeric"
    });
}
export function toWeekdayDayAndTime(date, language) {
    var locale = language == "sl" ? "sl-SI" : "en-UK";
    return "".concat(date.toLocaleDateString([
        locale
    ], {
        weekday: "long",
    }), ", ").concat(date.toLocaleDateString([
        locale
    ], {
        day: "2-digit",
        month: "long",
        year: "numeric"
    }), ", ").concat(date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
    }));
}
export function toWeekdayDay(date, language) {
    var locale = language == "sl" ? "sl-SI" : "en-UK";
    return "".concat(date.toLocaleDateString([
        locale
    ], {
        weekday: "long",
    }), ", ").concat(date.toLocaleDateString([
        locale
    ], {
        day: "2-digit",
        month: "long",
        year: "numeric"
    }));
}
